import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "asana",
  "name": "Asana",
  "category": "integrations",
  "description": "Manage Asana tasks, projects, subtasks, comments, tags, and users",
  "icon": "asana",
  "iconType": "integration-icon",
  "color": "pink",
  "version": "2.0.0",
  "group": [
    "transform"
  ],
  "subtitle": "={{$parameter.resource + \": \" + $parameter.operation}}",
  "defaults": {
    "name": "Asana",
    "color": "#f06a6a"
  },
  "credentials": [
    {
      "name": "asana_oauth2",
      "required": true,
      "displayName": "Asana OAuth2"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "asana",
    "tasks",
    "projects",
    "subtasks",
    "project-management",
    "productivity"
  ],
  "comingSoon": false
};

export default definition;
